"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.brandTypes = void 0;
exports.brandTypes = {
    SET_LOADING: 'BRAND TYPES SET LOADING',
    SET_ERROR: 'SILO TYPES REDUCER SET ERROR',
    SET_DATA_GRID: 'BRAND TYPES GET DATA GRID',
    ON_PAGE_CHANGE: 'BRAND TYPES ON PAGE CHANGE',
    ON_MUTATION_CLICK: 'BRAND TYPES ON MUTATION',
    ON_SORT_CHANGE: 'BRAND TYPES ON SORT CHANGE',
    ON_SAVE_DATAITEM: 'BRAND TYPES ON SAVE DATAITEM',
    ON_FILTER_CHANGE: 'BRAND TYPES ON FILTER CHANGE',
    ON_DELETE_DATAITEM: 'BRAND TYPES ON DELETE DATAITEM',
    ON_CHANGE_DATAITEM: 'BRAND TYPES ON CHANGE DATAITEM',
    TOGGLE_SUCCESS_MODAL: 'DRIVER TYPES SET SUCCESS MODAL',
    SET_DATA_ENUM: 'BRAND TYPES GET DATA ENUM',
};
